import { getBusinesses } from '../../../data/repositories/businessRepository.js';

export const fetchBusinesses = (params) => getBusinesses(params);
